module.exports = __webpack_public_path__ + "img/couples-014.279ff643.jpg";